/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React, { useContext, useState } from 'react';
import loader from '../../../../../assets/img/icons/TizetiLoaderColored.gif';

import view from '../../../../../assets/img/icons/view.png';
import Details from './Details';
import { DedicatedContext } from '../../../../../context/sales/DedicatedContext';

const CustomersTable = () => {
  const { dedicatedCustomers, loading } = useContext(DedicatedContext);
  const [one, setOne] = useState({});
  if (loading)
    return (
      <tbody>
        <tr>
          <td>
            <img src={loader} alt="" />
          </td>
        </tr>
      </tbody>
    );

  const customerList = dedicatedCustomers ? (
    dedicatedCustomers.map((customer, i) => (
      <tr key={customer.id}>
        <td>{i + 1}</td>
        <td>{customer.name}</td>
        <td>{customer.email}</td>
        <td>{customer.expiration_date}</td>
        <td>{customer.price}</td>
        <td>{customer.address}</td>
        <td>{customer.item_code}</td>
        <td>{customer.mac_id}</td>
        <td>
          <div className="d-flex">
            <button
              type="submit"
              data-toggle="modal"
              data-placement="right"
              onClick={() => setOne(customer)}
              data-target="#dedicated-detail"
              style={{
                border: '0',
                backgroundColor: 'white',
              }}
            >
              <span className="view1">
                <img src={view} alt="" data-toggle="tooltip" data-placement="right" title="View" />
              </span>
            </button>
            <Details one={one} />
          </div>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td>
        <p>No customers!</p>
      </td>
    </tr>
  );

  return <tbody>{customerList}</tbody>;
};

export default CustomersTable;
